module.exports = __webpack_public_path__ + "static/media/shannonairport.196b1355.png";